import React from 'react'
import { withFormik, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Container, Button, Label, Modal, } from 'semantic-ui-react';
import { MyInput } from '../../apiInputComponent/myInput';
import Axios from 'axios';
import APP_CONSTANT from '../../../config/constants';
import CreateAxios from '../../axiosComponent/create';
import UpdateAxios from '../../axiosComponent/update';
import cogoToast from 'cogo-toast';

const AddBranch = ({ values, errors, touched, isSubmitting, handleSubmit, handleClose }) => {
    return (
        <>
            <Modal.Content>
                <Container>
                    <div className="ui form">
                        <FormUi.Field>
                            <label className="labelName p-bold-600">Branch Code *</label>
                            <Fieldmik component={MyInput} error={values.branchCode ? false : true} name="branchCode" placeholder="Code" />
                            {touched.branchCode && errors.branchCode ? <Label size="mini" prompt pointing>{errors.branchCode}</Label> : ''}
                        </FormUi.Field>
                        <FormUi.Field>
                            <label className="labelName p-bold-600">Branch Name *</label>
                            <Fieldmik component={MyInput} error={values.branchName ? false : true} name="branchName" placeholder="Name" />
                            {touched.branchName && errors.branchName ? <Label size="mini" prompt pointing>{errors.branchName}</Label> : ''}
                        </FormUi.Field>
                        <FormUi.Field inline>
                            <Fieldmik className="ui checkbox" name="isGSTExempted" type="checkbox" />
                            <label className="labelName p-bold-600"> Exempt GST</label>
                            {touched.isGSTExempted && errors.isGSTExempted ? <Label size="mini" prompt pointing>{errors.isGSTExempted}</Label> : ''}
                        </FormUi.Field>
                    </div>
                </Container>
            </Modal.Content>
            <Modal.Actions>
                {isSubmitting ? 'Loading...' : ''}
                <Button onClick={handleClose} type="submit" size="tiny">Cancel</Button>
                <Button disabled={isSubmitting} onClick={handleSubmit} size="tiny" primary>Submit</Button>
            </Modal.Actions>
        </>
    )
}

const FormikAddBranch = withFormik({
    enableReinitialize: true,
    mapPropsToValues(props) {
        // console.log('pr', props)
        return {
            branchCode: props.branchArray.code || '',
            branchName: props.branchArray.name || '',
            branchId: props.branchArray.id || '',
            isGSTExempted: props.branchArray.isGSTExempted === 1 ? true : false,
        }
    },
    validationSchema: yup.object().shape({
        branchCode: yup.string().matches(/^[^\s].+$/, 'No Blank Space Require').min(3, 'Must be more than 3 Letters').required('Branch Code Required'),
        branchName: yup.string().matches(/^[^\s].+$/, 'No Blank Space Require').min(3, 'Must be more than 3 Letters').required('Branch Name Required'),
        isGSTExempted: yup.string().optional()
    }),
    handleSubmit(values, { props, setSubmitting }) {
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        if (props.branchArray.id) {
            let branchData = JSON.stringify({
                api_token: token,
                branchCode: values.branchCode,
                branchName: values.branchName,
                isGSTExempted: values.isGSTExempted ? 1 : 0,
                customerNumber: customerNo,
                userId: userId
            })
            Axios.patch(`${APP_CONSTANT.BASE_URL}masters/branch/${props.branchArray.id}`, branchData, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then(response => {
                if (response.data.status === 200) {
                    cogoToast.success(response.data.message)
                    setTimeout(() => {                       
                        window.location.reload()
                    }, 500);
                } else {
                    setSubmitting(false)
                    cogoToast.error(response.data.message)
                }
            })
        } else {
            
            let branchData = JSON.stringify({
                api_token: token,
                branchCode: values.branchCode,
                branchName: values.branchName,
                isGSTExempted: values.isGSTExempted ? 1 : 0,
                customerNumber: customerNo,
                userId: userId
            })
            Axios.put(`${APP_CONSTANT.BASE_URL}masters/branch`, branchData, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then(response => {
                if (response.data.status === 200) {
                    cogoToast.success(response.data.message)
                    setTimeout(() => {
                        window.location.reload()
                    }, 500);
                } else {
                    setSubmitting(false)
                    cogoToast.error(response.data.message)
                    // alert(response.data.message)
                }
            })
        }

    }
})(AddBranch)

export default FormikAddBranch
